const KanbanEmptyCell = () => {
  return (
    <div className="p-[10px] !h-auto w-full flex items-center justify-center bg-[#D0DAE2] dark:bg-neutral-800">
      <div className="bg-[#E5EBF0] dark:bg-neutral-900 border border-[#344054] dark:border-neutral-700 rounded-lg p-4 w-full h-[220px] flex items-center justify-center">
        <span className="text-gray-400 dark:text-neutral-500">-</span>
      </div>
    </div>
  );
};

export default KanbanEmptyCell;
